export default function replaceDecimalComma(numStr: string) {
  return numStr.replace(/,/, ".");
}
